import React from "react";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import {makeStyles} from "@material-ui/core/styles";
import {Link as RouterLink} from "react-router-dom";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";

import {Brand} from "../Brand";

const useLocalStyles = makeStyles(theme => ({
  footer: {
    // anchor to the bottom
    left: 0,
    right: 0,
    bottom: 0,
    position: 'fixed',
    ...Brand.styles.footer_brand,
  },
  footerGridContainer: {
    // NOTE: the following is made to take a height which is exactly equal to
    // the top bar (56px at the moment < md, and 64px >= md)
    height: '56px',
    [theme.breakpoints.up('sm')]: {
      height: '64px',
    },
  },
  footerGridItem: {
    marginTop: 'auto',
    marginBottom: 'auto',
  },
  footerButton: {
    color: Brand.styles.footer_brand.color,
    fontWeight: 'normal',
    marginTop: 'auto',
    marginBottom: 'auto',
    marginLeft: 'auto',
  },
}));

export function Footer(/*props*/) {
  const classes = useLocalStyles();
  return <footer className={classes.footer}>
    <Container maxWidth="md">
      <Grid container className={classes.footerGridContainer}>
        <Grid item xs={8} className={classes.footerGridItem}>
          <Typography variant="body1">
            {`${Brand.appName} ${new Date().getFullYear()}`}. Fan Art.<br/>{/* Do Not Use */}
          </Typography>
        </Grid>
        <Button component={RouterLink} to={"/terms"} className={classes.footerButton}>
          Terms
        </Button>
      </Grid>
    </Container>
  </footer>;
}
